/**
 * A lot's specifications, as a table.
 *
 * 🔴 EXTRACTED FROM `PublicLotDetail` (2026-09-15) so there is ONE of these.
 * Focused Watch shows a lot's details under the hero now, and a second
 * specifications table would drift from this one the first time a tenant added
 * a field. Behaviour is unchanged — this is a move, not a rewrite.
 *
 * ⚠️ SPECS ARE NOT A LOT FIELD. They live on `inventory_items.custom_fields`,
 * reached through the lot's `inventory_item_id`, which is why the lot page
 * fetches them separately. Any caller has to bring them; this component only
 * renders what it is given, and renders nothing when there is nothing to show.
 */
const SPEC_LABELS: Record<string, string> = {
  brand: 'Brand',
  model: 'Model',
  year: 'Year',
  material: 'Material',
  color: 'Color',
  dimensions: 'Dimensions',
};
const SPEC_ORDER = ['brand', 'model', 'year', 'material', 'color', 'dimensions'];

function formatSpecValue(v: unknown): string {
  if (v === null || v === undefined || v === '') return '';
  if (typeof v === 'string') return v;
  if (typeof v === 'number') return String(v);
  if (typeof v === 'boolean') return v ? 'yes' : 'no';
  return '';
}

function titleCase(s: string): string {
  return s
    .replace(/_/g, ' ')
    .replace(/\w\S*/g, (t) => t.charAt(0).toUpperCase() + t.slice(1).toLowerCase());
}

export function SpecsTable({
  specs,
  headingSize = 20,
}: {
  specs: Record<string, unknown>;
  /** Focused Watch sits inside a column and wants the smaller heading. */
  headingSize?: number;
}) {
  const rows: { label: string; value: string }[] = [];
  // Known specs first in canonical order.
  for (const key of SPEC_ORDER) {
    const v = specs[key];
    const label = SPEC_LABELS[key] ?? titleCase(key);
    const display = formatSpecValue(v);
    if (display) rows.push({ label, value: display });
  }
  // Then anything custom the tenant has added that we didn't know about.
  for (const [k, v] of Object.entries(specs)) {
    if (SPEC_LABELS[k]) continue;
    const display = formatSpecValue(v);
    if (display) rows.push({ label: titleCase(k), value: display });
  }
  if (rows.length === 0) return null;
  return (
    <section className="w-sec" style={{ paddingTop: 30 }}>
      <h2 className="w-h2" style={{ fontSize: headingSize, marginBottom: 14 }}>
        Specifications
      </h2>
      <div
        style={{
          border: '1px solid var(--border)',
          borderRadius: 'var(--r-card)',
          padding: '4px 18px',
        }}
      >
        {rows.map((r) => (
          <div className="w-kv" key={r.label}>
            <span className="muted">{r.label}</span>
            <span>{r.value}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
